import styled from 'styled-components';
import { Col, Image, type ImageProps } from 'antd';

interface ThumbnailProps extends ImageProps {
	$hasError: boolean;
}

export const Container = styled(Col)`
	position: relative;
	border-radius: 6px;
	.ant-image {
		border-radius: 6px;
		img {
			height: 270px;
			width: 400px;
			object-fit: cover;
			border-radius: 6px;
			box-shadow: 1px 1px 5px 0px #00000026;
		}
	}
	&:hover .actions {
		opacity: 1;
		visibility: visible;
	}
`;

export const Thumbnail = styled(Image)<ThumbnailProps>`
	height: 100%;
	width: 100%;
	border: ${({ $hasError }) => ($hasError ? '1px solid #E74150' : 'none')};
`;

export const Actions = styled(Col)`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0;
	visibility: hidden;
	border-radius: 6px;
	background-color: #fffffff2;
	.ant-col {
		display: flex;
		justify-content: center;
		button {
			border: none;
			color: #2f54eb;
			background: transparent;
			.ant-col {
				padding: 0 !important;
			}
			svg {
				font-size: 2rem;
			}
			&:disabled {
				color: #d9d9d9;
			}
		}
		button.ant-btn-dangerous {
			color: #ff4d4f;
			background: transparent;
		}
	}
`;
